//
//
//
//

export default {
  props: {
    isEternal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      label: '',
    };
  },
  created() {
    this.label = this.isEternal
      ? this.$t('saleBlock.eternal.button.label')
      : this.$t('saleBlock.button.label');
  },
};
